import styled from '@emotion/styled';
import css from '@styled-system/css';

export const ModalHeader = styled('div')(
  css({
    position: 'relative',
    px: '2x_big',
    py: 'big',
    borderBottom: '1px solid',
    borderColor: 'neutral.40',
  })
);
